import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

//for custom MUI DialogTitle
const DialogTitleStyle = {
  color: "#fff",
  backgroundColor: "#1553b5 ",
  display: "flex",
  justifyContent: "space-between",
};

const FileHistory = ({ historyOpen, setHistoryOpen, data }) => {
  return (
    <Dialog
      open={historyOpen}
      TransitionComponent={Transition}
      onClose={() => setHistoryOpen(false)}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth="md" //You can change md to sm, xs, lg and xl as per your requirement.
      PaperProps={{
        sx: {
          overflow: "visible"
        }
      }}
    >
      <div
        style={{
          backgroundColor: "#f4f4f4",
          position: "relative",
        }}
      >
        <CloseIcon
          style={{
            color: "#171717",
            position: "absolute",
            top: -10,
            right: "50%",
            fontSize: "25px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            padding: "3px",
            zIndex: 1000,
          }}
          onClick={() => {
            setHistoryOpen(false);
          }}
        />
        <DialogTitle id="scroll-dialog-title" sx={DialogTitleStyle}>
          History
        </DialogTitle>
        {historyOpen && (
          <DialogContent dividers="paper" style={{ minHeight: 516, maxHeight: "80vh" }}>
            {!data || data.length === 0 ? (
              <Box
                height={300}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                No Data to show
              </Box>
            ) : (
              <TableContainer
                component={Paper}
                sx={{
                  border: "1px solid #fff",
                }}
              >
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>User</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((item) => (
                      <TableRow>
                        <TableCell>{`${item?.user?.firstName} ${item?.user?.lastName} / ${item?.user?.district}`}</TableCell>
                        <TableCell>
                          {new Date(item?.date).toLocaleString()}
                        </TableCell>
                        <TableCell>{item?.action}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DialogContent>
        )}
      </div>
    </Dialog>
  );
};

export default FileHistory;
